
export default {
  name:"UnAutorized",
    components:{
    },
    setup() {
  }
    
};
